// Dock yüksekliği, alt konumu ve liste boşluğu aynı geometriden türetilir.
// Güvenli alan ekranda eklenir; home indicator olmayan cihazlarda sıfırdır.
// D-801 restores the shared capsule's original geometry, preserving current
// crisp symbols. Fixed 260 pt width fits 320 pt screens without a resize snapshot.
export const floatingDockMetrics = {
  tabSize: 44,
  tabGap: 4,
  horizontalPadding: 12,
  verticalPadding: 6,
  bottomOffset: 16,
  contentGap: 16,
  badgeTop: 4,
  badgeRight: 2,
} as const;

export const floatingDockHeight = floatingDockMetrics.tabSize + 2 * floatingDockMetrics.verticalPadding;
export const floatingDockScrollInset = floatingDockHeight + floatingDockMetrics.bottomOffset;
export const floatingDockContentInset = floatingDockScrollInset + floatingDockMetrics.contentGap;
